// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Page Layout ─────────────────────────────────────────────────────────── */
.returns-v2-page {
  min-height: 100vh;
  background: radial-gradient(circle at top right, rgba(42, 113, 255, 0.1), transparent 28%),
    linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);
  color: #0f172a;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  padding-bottom: 70px;
  width: 100%;
}

.returns-v2-inner {
  max-width: 1024px;
  margin: 0 auto;
  padding: 16px 24px;
}

/* ─── Top Header Bar ──────────────────────────────────────────────────────── */
.returns-v2-topbar {
  position: sticky;
  top: 0;
  z-index: 20;
  border-bottom: 1px solid rgba(255, 255, 255, 0.7);
  background: linear-gradient(180deg, rgba(248, 250, 252, 0.96) 0%, rgba(248, 250, 252, 0.88) 100%);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  padding-top: 70px;
}

.returns-v2-topbar-inner {
  max-width: 1024px;
  margin: 0 auto;
  padding: 14px 24px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.returns-v2-topbar-left {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  min-width: 0;
}

.returns-v2-back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
  cursor: pointer;
  transition:
    border-color 0.15s,
    background 0.15s;
}

.returns-v2-back-btn:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
}

.returns-v2-back-btn svg {
  width: 20px;
  height: 20px;
}

.returns-v2-title-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.returns-v2-title {
  font-size: 22px;
  font-weight: 700;
  color: #020617;
  line-height: 1.3;
  margin: 0;
}

.returns-v2-status-badge {
  display: inline-flex;
  border-radius: 9999px;
  padding: 4px 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}

.returns-v2-status-badge.returned {
  border: 1px solid #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

.returns-v2-reprint-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  flex-shrink: 0;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #334155;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: background 0.15s;
}

.returns-v2-reprint-btn:hover {
  background: #f8fafc;
}

.returns-v2-reprint-btn svg {
  width: 16px;
  height: 16px;
}

/* ─── Content Area ────────────────────────────────────────────────────────── */
.returns-v2-content {
  max-width: 1024px;
  margin: 0 auto;
  padding: 16px 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ─── Glass Card ──────────────────────────────────────────────────────────── */
.rv2-card {
  border-radius: 26px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.06);
  padding: 16px;
}

/* ─── Meta Header (4-col grid) ────────────────────────────────────────────── */
.rv2-meta-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.rv2-meta-cell {
  border-radius: 18px;
  border: 1px solid #f1f5f9;
  background: rgba(248, 250, 252, 0.7);
  padding: 12px 16px;
}

.rv2-meta-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #94a3b8;
  margin: 0 0 8px;
}

.rv2-meta-value {
  font-size: 14px;
  font-weight: 700;
  color: #020617;
  margin: 0;
}

/* ─── Two-column body ─────────────────────────────────────────────────────── */
.rv2-body-grid {
  display: grid;
  grid-template-columns: 270px 1fr;
  gap: 16px;
}

/* ─── Timeline card ───────────────────────────────────────────────────────── */
.rv2-timeline-card {
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.05);
  padding: 16px;
  align-self: start;
}

.rv2-timeline-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
}

.rv2-timeline-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 16px;
  background: #eff6ff;
  color: #2a71ff;
  flex-shrink: 0;
}

.rv2-timeline-icon-wrap svg {
  width: 16px;
  height: 16px;
}

.rv2-timeline-header-text p {
  margin: 0;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #94a3b8;
}

.rv2-timeline-header-text h2 {
  margin: 4px 0 0;
  font-size: 16px;
  font-weight: 700;
  color: #020617;
}

.rv2-timeline-items {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.rv2-timeline-item {
  position: relative;
  padding-left: 40px;
}

.rv2-timeline-item:not(:last-child)::before {
  content: "";
  position: absolute;
  left: 15px;
  top: 36px;
  width: 1px;
  height: calc(100% + 16px);
  background: #e2e8f0;
}

.rv2-timeline-dot {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
}

.rv2-timeline-dot svg {
  width: 14px;
  height: 14px;
}

.rv2-timeline-event-name {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
}

.rv2-timeline-actor {
  margin: 4px 0 0;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #94a3b8;
}

.rv2-timeline-time {
  margin: 4px 0 0;
  font-size: 12px;
  color: #64748b;
}

/* ─── Right panel ─────────────────────────────────────────────────────────── */
.rv2-right-panel {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.rv2-info-cards-row {
  display: grid;
  grid-template-columns: 0.95fr 1.05fr 0.9fr;
  gap: 16px;
}

.rv2-info-card {
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.05);
  padding: 16px;
}

.rv2-info-card-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #94a3b8;
  margin: 0 0 16px;
}

.rv2-info-fields {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.rv2-field-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #94a3b8;
  margin: 0 0 6px;
}

.rv2-field-value {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
}

/* summary rows */
.rv2-summary-rows {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rv2-summary-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 16px;
  border: 1px solid #f1f5f9;
  background: rgba(248, 250, 252, 0.7);
  padding: 12px 16px;
}

.rv2-summary-row-key {
  font-size: 14px;
  color: #64748b;
}

.rv2-summary-row-val {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  text-align: right;
}

/* refund cells */
.rv2-refund-cells {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rv2-refund-cell {
  border-radius: 16px;
  border: 1px solid #f1f5f9;
  background: rgba(248, 250, 252, 0.7);
  padding: 12px 16px;
}

/* ─── Items Table card ────────────────────────────────────────────────────── */
.rv2-table-card {
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.05);
  overflow: hidden;
}

.rv2-table-card-header {
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
}

.rv2-table-card-header p {
  margin: 0;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #94a3b8;
}

.rv2-table-wrap {
  overflow-x: auto;
}

.rv2-items-table {
  width: 100%;
  min-width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  text-align: left;
}

.rv2-items-table thead tr {
  border-bottom: 1px solid #f1f5f9;
  background: rgba(248, 250, 252, 0.7);
}

.rv2-items-table th {
  padding: 12px 16px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #94a3b8;
  white-space: nowrap;
}

.rv2-items-table th.text-right,
.rv2-items-table td.text-right {
  text-align: right;
}

.rv2-items-table tbody tr {
  border-bottom: 1px solid #f1f5f9;
}

.rv2-items-table tbody tr:last-child {
  border-bottom: none;
}

.rv2-items-table td {
  padding: 12px 16px;
  color: #475569;
}

.rv2-items-table td.item-name {
  font-weight: 600;
  color: #0f172a;
}

.rv2-items-table td.item-amount {
  font-weight: 600;
  color: #0f172a;
  text-align: right;
}

/* ─── Loading / Error states ──────────────────────────────────────────────── */
.rv2-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  font-size: 14px;
  color: #64748b;
  gap: 10px;
}

.rv2-spinner {
  width: 24px;
  height: 24px;
  border: 2px solid #e2e8f0;
  border-top-color: #2a71ff;
  border-radius: 50%;
  animation: rv2-spin 0.7s linear infinite;
}

@keyframes rv2-spin {
  to {
    transform: rotate(360deg);
  }
}

.rv2-error {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  font-size: 14px;
  color: #be123c;
}

/* ─── Responsive ─────────────────────────────────────────────────────────── */
@media (max-width: 768px) {
  .rv2-meta-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .rv2-body-grid {
    grid-template-columns: 1fr;
  }

  .rv2-info-cards-row {
    grid-template-columns: 1fr;
  }

  .returns-v2-topbar-inner,
  .returns-v2-content {
    padding-left: 16px;
    padding-right: 16px;
  }
}

/* ─── Grid Table ──────────────────────────────────────────────────────────── */
.rv2-grid-table {
  display: flex;
  flex-direction: column;
}

.rv2-grid-head,
.rv2-grid-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  border-bottom: 1px solid #f1f5f9;
}

.rv2-grid-row:last-child {
  border-bottom: none;
}

.rv2-grid-head {
  background: rgba(248, 250, 252, 0.7);
}

.rv2-grid-head span {
  padding: 12px 16px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #94a3b8;
}

.rv2-grid-head span.text-right {
  text-align: right;
}

.rv2-grid-item-name {
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  display: flex;
  align-items: center;
}

.rv2-grid-cell {
  padding: 12px 16px;
  font-size: 14px;
  color: #475569;
  display: flex;
  align-items: center;
}

.rv2-grid-cell--right {
  justify-content: flex-end;
  font-weight: 600;
  color: #0f172a;
}

.rv2-grid-empty {
  padding: 24px;
  text-align: center;
  color: #94a3b8;
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/Returns/ReturnsDetails.css"],"names":[],"mappings":"AAAA,gFAAgF;AAChF;EACE,iBAAiB;EACjB;qDACmD;EACnD,cAAc;EACd,8EAA8E;EAC9E,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA,gFAAgF;AAChF;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,iDAAiD;EACjD,iGAAiG;EACjG,2BAA2B;EAC3B,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf;;oBAEkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,gFAAgF;AAChF;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,gFAAgF;AAChF;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,8CAA8C;EAC9C,aAAa;AACf;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA,gFAAgF;AAChF;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,8CAA8C;EAC9C,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,gFAAgF;AAChF;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB","sourcesContent":["/* ─── Page Layout ─────────────────────────────────────────────────────────── */\n.returns-v2-page {\n  min-height: 100vh;\n  background: radial-gradient(circle at top right, rgba(42, 113, 255, 0.1), transparent 28%),\n    linear-gradient(180deg, #f8fafc 0%, #eef4ff 100%);\n  color: #0f172a;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  padding-bottom: 70px;\n  width: 100%;\n}\n\n.returns-v2-inner {\n  max-width: 1024px;\n  margin: 0 auto;\n  padding: 16px 24px;\n}\n\n/* ─── Top Header Bar ──────────────────────────────────────────────────────── */\n.returns-v2-topbar {\n  position: sticky;\n  top: 0;\n  z-index: 20;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.7);\n  background: linear-gradient(180deg, rgba(248, 250, 252, 0.96) 0%, rgba(248, 250, 252, 0.88) 100%);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  padding-top: 70px;\n}\n\n.returns-v2-topbar-inner {\n  max-width: 1024px;\n  margin: 0 auto;\n  padding: 14px 24px;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.returns-v2-topbar-left {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  min-width: 0;\n}\n\n.returns-v2-back-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  color: #475569;\n  cursor: pointer;\n  transition:\n    border-color 0.15s,\n    background 0.15s;\n}\n\n.returns-v2-back-btn:hover {\n  border-color: #cbd5e1;\n  background: #f8fafc;\n}\n\n.returns-v2-back-btn svg {\n  width: 20px;\n  height: 20px;\n}\n\n.returns-v2-title-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n}\n\n.returns-v2-title {\n  font-size: 22px;\n  font-weight: 700;\n  color: #020617;\n  line-height: 1.3;\n  margin: 0;\n}\n\n.returns-v2-status-badge {\n  display: inline-flex;\n  border-radius: 9999px;\n  padding: 4px 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n}\n\n.returns-v2-status-badge.returned {\n  border: 1px solid #fecdd3;\n  background: #fff1f2;\n  color: #be123c;\n}\n\n.returns-v2-reprint-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 40px;\n  padding: 0 16px;\n  flex-shrink: 0;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  color: #334155;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  transition: background 0.15s;\n}\n\n.returns-v2-reprint-btn:hover {\n  background: #f8fafc;\n}\n\n.returns-v2-reprint-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* ─── Content Area ────────────────────────────────────────────────────────── */\n.returns-v2-content {\n  max-width: 1024px;\n  margin: 0 auto;\n  padding: 16px 24px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ─── Glass Card ──────────────────────────────────────────────────────────── */\n.rv2-card {\n  border-radius: 26px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.06);\n  padding: 16px;\n}\n\n/* ─── Meta Header (4-col grid) ────────────────────────────────────────────── */\n.rv2-meta-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n}\n\n.rv2-meta-cell {\n  border-radius: 18px;\n  border: 1px solid #f1f5f9;\n  background: rgba(248, 250, 252, 0.7);\n  padding: 12px 16px;\n}\n\n.rv2-meta-label {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: #94a3b8;\n  margin: 0 0 8px;\n}\n\n.rv2-meta-value {\n  font-size: 14px;\n  font-weight: 700;\n  color: #020617;\n  margin: 0;\n}\n\n/* ─── Two-column body ─────────────────────────────────────────────────────── */\n.rv2-body-grid {\n  display: grid;\n  grid-template-columns: 270px 1fr;\n  gap: 16px;\n}\n\n/* ─── Timeline card ───────────────────────────────────────────────────────── */\n.rv2-timeline-card {\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.05);\n  padding: 16px;\n  align-self: start;\n}\n\n.rv2-timeline-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.rv2-timeline-icon-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 16px;\n  background: #eff6ff;\n  color: #2a71ff;\n  flex-shrink: 0;\n}\n\n.rv2-timeline-icon-wrap svg {\n  width: 16px;\n  height: 16px;\n}\n\n.rv2-timeline-header-text p {\n  margin: 0;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: #94a3b8;\n}\n\n.rv2-timeline-header-text h2 {\n  margin: 4px 0 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #020617;\n}\n\n.rv2-timeline-items {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.rv2-timeline-item {\n  position: relative;\n  padding-left: 40px;\n}\n\n.rv2-timeline-item:not(:last-child)::before {\n  content: \"\";\n  position: absolute;\n  left: 15px;\n  top: 36px;\n  width: 1px;\n  height: calc(100% + 16px);\n  background: #e2e8f0;\n}\n\n.rv2-timeline-dot {\n  position: absolute;\n  left: 0;\n  top: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  color: #475569;\n}\n\n.rv2-timeline-dot svg {\n  width: 14px;\n  height: 14px;\n}\n\n.rv2-timeline-event-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0f172a;\n  margin: 0;\n}\n\n.rv2-timeline-actor {\n  margin: 4px 0 0;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: #94a3b8;\n}\n\n.rv2-timeline-time {\n  margin: 4px 0 0;\n  font-size: 12px;\n  color: #64748b;\n}\n\n/* ─── Right panel ─────────────────────────────────────────────────────────── */\n.rv2-right-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.rv2-info-cards-row {\n  display: grid;\n  grid-template-columns: 0.95fr 1.05fr 0.9fr;\n  gap: 16px;\n}\n\n.rv2-info-card {\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.05);\n  padding: 16px;\n}\n\n.rv2-info-card-label {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: #94a3b8;\n  margin: 0 0 16px;\n}\n\n.rv2-info-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.rv2-field-label {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: #94a3b8;\n  margin: 0 0 6px;\n}\n\n.rv2-field-value {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0f172a;\n  margin: 0;\n}\n\n/* summary rows */\n.rv2-summary-rows {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.rv2-summary-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 16px;\n  border: 1px solid #f1f5f9;\n  background: rgba(248, 250, 252, 0.7);\n  padding: 12px 16px;\n}\n\n.rv2-summary-row-key {\n  font-size: 14px;\n  color: #64748b;\n}\n\n.rv2-summary-row-val {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0f172a;\n  text-align: right;\n}\n\n/* refund cells */\n.rv2-refund-cells {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.rv2-refund-cell {\n  border-radius: 16px;\n  border: 1px solid #f1f5f9;\n  background: rgba(248, 250, 252, 0.7);\n  padding: 12px 16px;\n}\n\n/* ─── Items Table card ────────────────────────────────────────────────────── */\n.rv2-table-card {\n  border-radius: 24px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.05);\n  overflow: hidden;\n}\n\n.rv2-table-card-header {\n  padding: 12px 16px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.rv2-table-card-header p {\n  margin: 0;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: #94a3b8;\n}\n\n.rv2-table-wrap {\n  overflow-x: auto;\n}\n\n.rv2-items-table {\n  width: 100%;\n  min-width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n  text-align: left;\n}\n\n.rv2-items-table thead tr {\n  border-bottom: 1px solid #f1f5f9;\n  background: rgba(248, 250, 252, 0.7);\n}\n\n.rv2-items-table th {\n  padding: 12px 16px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: #94a3b8;\n  white-space: nowrap;\n}\n\n.rv2-items-table th.text-right,\n.rv2-items-table td.text-right {\n  text-align: right;\n}\n\n.rv2-items-table tbody tr {\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.rv2-items-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.rv2-items-table td {\n  padding: 12px 16px;\n  color: #475569;\n}\n\n.rv2-items-table td.item-name {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.rv2-items-table td.item-amount {\n  font-weight: 600;\n  color: #0f172a;\n  text-align: right;\n}\n\n/* ─── Loading / Error states ──────────────────────────────────────────────── */\n.rv2-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 300px;\n  font-size: 14px;\n  color: #64748b;\n  gap: 10px;\n}\n\n.rv2-spinner {\n  width: 24px;\n  height: 24px;\n  border: 2px solid #e2e8f0;\n  border-top-color: #2a71ff;\n  border-radius: 50%;\n  animation: rv2-spin 0.7s linear infinite;\n}\n\n@keyframes rv2-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.rv2-error {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n  font-size: 14px;\n  color: #be123c;\n}\n\n/* ─── Responsive ─────────────────────────────────────────────────────────── */\n@media (max-width: 768px) {\n  .rv2-meta-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .rv2-body-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .rv2-info-cards-row {\n    grid-template-columns: 1fr;\n  }\n\n  .returns-v2-topbar-inner,\n  .returns-v2-content {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n}\n\n/* ─── Grid Table ──────────────────────────────────────────────────────────── */\n.rv2-grid-table {\n  display: flex;\n  flex-direction: column;\n}\n\n.rv2-grid-head,\n.rv2-grid-row {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr 1fr;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.rv2-grid-row:last-child {\n  border-bottom: none;\n}\n\n.rv2-grid-head {\n  background: rgba(248, 250, 252, 0.7);\n}\n\n.rv2-grid-head span {\n  padding: 12px 16px;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: #94a3b8;\n}\n\n.rv2-grid-head span.text-right {\n  text-align: right;\n}\n\n.rv2-grid-item-name {\n  padding: 12px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #0f172a;\n  display: flex;\n  align-items: center;\n}\n\n.rv2-grid-cell {\n  padding: 12px 16px;\n  font-size: 14px;\n  color: #475569;\n  display: flex;\n  align-items: center;\n}\n\n.rv2-grid-cell--right {\n  justify-content: flex-end;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.rv2-grid-empty {\n  padding: 24px;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
